import ApiService from './api';

class ReviewsApiService {
  async getForm(reviewType, recipientId) {
    try {
      let url = `reviews/form?review_type=${reviewType}`;
      if (recipientId) {
        url += `&recipient_id=${recipientId}`;
      }
      return await ApiService.get(url);
    } catch (error) {
      console.error('Failed to get review form:', error);
      throw new Error('Unable to load review form');
    }
  }

  async submit({ booking_id, member_id, fields, badge_keys }) {
    try {
      const data = {
        booking_id,
        member_id,
        fields
      };
      if (Array.isArray(badge_keys) && badge_keys.length > 0) {
        data.badge_keys = badge_keys;
      }
      return await ApiService.post('reviews/submit', data);
    } catch (error) {
      console.error('Failed to submit review:', error);
      throw error;
    }
  }

  async list({ member_id, page = 1, per_page = 10, status }) {
    try {
      const params = new URLSearchParams({ 
        member_id: member_id.toString(), 
        page: page.toString(), 
        per_page: per_page.toString() 
      });
      if (status) params.set('status', status);
      return await ApiService.get(`reviews/list?${params}`);
    } catch (error) {
      console.error('Failed to get reviews list:', error);
      throw error;
    }
  }

  async respond({ review_id, content }) {
    try {
      return await ApiService.post('reviews/respond', {
        review_id,
        content
      });
    } catch (error) {
      console.error('Failed to submit review response:', error);
      throw error;
    }
  }

  async stats({ member_id }) {
    try {
      return await ApiService.get(`reviews/stats?member_id=${member_id}`);
    } catch (error) {
      console.error('Failed to get review stats:', error);
      throw error;
    }
  }

  async getReview(reviewId) {
    try {
      return await ApiService.get(`reviews/${reviewId}`);
    } catch (error) {
      console.error('Failed to get review:', error);
      throw error;
    }
  }
}

export default new ReviewsApiService();
